module.exports = __webpack_public_path__ + "img/support-adv-05.b0265706.png";